import { Box, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

const UNSPLASH_ACCESS_KEY = 'yrSvuxwChZT_YhZm-8deptyCxtvdemUKStz8jWaDucE'

export default function SearchBackground({imageSearch,setImageSearch}) {
const [imageRender, setImageRender] = useState([])
const [keyword,setKeyword] = useState('')
const [valueKeyWord, setValueKeyWord] = useState()
const [page,setPage] = useState(1)
useEffect(() =>{
    if(keyword?.length>0){
        handleSearchImage(page,imageRender,setImageRender,keyword)
    }else{
        handleSearchImageInit(page,imageRender,setImageRender)
    }
},[page,keyword])
  useEffect(() =>{
        const element = document.getElementById("render-image-search")
        const pageScroll = () => {
            const scrollTop = element.scrollTop
            const scrollHeight = element.scrollHeight
            const diff = scrollHeight - scrollTop
            const height = element.clientHeight
        if(Math.floor(diff) == Math.floor(height) || Math.floor(diff) == Math.floor(height)+1) {
          setPage(page+1)
                  
        }
        }
        element.addEventListener('scroll', pageScroll)
        return () => {
            element.removeEventListener('scroll', pageScroll)
        }
  },[page])
    const data = imageRender
  return (
    <Box sx={{padding: '0 !important'}}>
        <Box sx={{display:'flex', padding:'10px'}}>
            <TextField
                label="Search"
                fullWidth
                onChange={(e)=>{setValueKeyWord(e.target.value)}}
                variant="standard"
            />
            <IconButton style={{width:'45px'}} color="primary" variant='outlined' onClick={(e)=>{
                setPage(1)
                setImageRender([])
                setKeyword(valueKeyWord)
            }}>
                <SearchIcon />
            </IconButton>
        </Box>
        <Box sx={{padding: '0 !important',height:'400px', overflow:'auto'}} id="render-image-search">
            
        {
            data.length > 0 &&
            <Grid container>
                <Grid item xs={6} >
                    {
                        data?.[0]?.map((el) =>{
                            return(
                                <Box sx={{borderRadius:'5px', boxShadow: imageSearch == el.urls.regular ? 'inset 0 0 0 2px #262627' : 'unset'}}>
                                    <img 
                                        src={el.urls.thumb} 
                                        width="100%" 
                                        style={{"borderRadius":"8px","padding":"5px"}} 
                                        alt={el.alt_description} 
                                        onClick={() =>{setImageSearch(el.urls.regular)}}
                                    />
                                </Box>
                                
                            )
                        })
                    }
                </Grid>
                <Grid item xs={6} >
                    {
                        data?.[1]?.map((el) =>{
                            return(
                                <Box sx={{borderRadius:'5px', boxShadow: imageSearch == el.urls.regular ? 'inset 0 0 0 2px #262627' : 'unset'}}>
                                    <img 
                                        src={el.urls.thumb} 
                                        width="100%" 
                                        style={{"borderRadius":"8px","padding":"5px"}} 
                                        alt={el.alt_description} 
                                        onClick={() =>{setImageSearch(el.urls.regular)}}
                                    />
                                </Box>
                                
                            )
                        })
                    }
                </Grid>
            </Grid>
        }
        </Box>
    </Box>
  )
}


function handleSearchImageInit(page=1,imageRender=[],setImageRender){
    
    let key = UNSPLASH_ACCESS_KEY
    let url = 'https://api.unsplash.com/photos?client_id='+key+'&orientation=landscape&page='+page
    fetch(url)
    .then((response) => response.json())
    .then((data) => {
        if(data.length == 0){
            setImageRender([])
        }else{
            let dataSplit = splitToChunks(data,2)
            if(imageRender.length >0){
                dataSplit[0] = [...imageRender[0],...dataSplit[0]]
                dataSplit[1] = [...imageRender[1],...dataSplit[1]] 
            }
            setImageRender(dataSplit)
        }
        
    });
}

function handleSearchImage(page,imageRender,setImageRender,keyword){
    
    let key = UNSPLASH_ACCESS_KEY
    let url = 'https://api.unsplash.com/search/photos?client_id='+key+'&query='+keyword+'&orientation=landscape&page='+page
    fetch(url)
    .then((response) => response.json())
    .then((data) => {
        if(data.length == 0){
            setImageRender([])
        }else{
            let dataSplit = splitToChunks(data.results,2)
            
            if(imageRender.length >0){
                dataSplit[0] = [...imageRender[0],...dataSplit[0]]
                dataSplit[1] = [...imageRender[1],...dataSplit[1]] 
            }
            setImageRender(dataSplit)
        }
        
    });
    
}

function splitToChunks(array, parts) {
    let result = [];
    for (let i = parts; i > 0; i--) {
        result.push(array?.splice(0, Math.ceil(array.length / i)));
    }
    return result;
}